import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { withActionsExecutor, ActionsExecutorPropsType } from "components/actions";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Link } from 'react-router-dom';
import { Grid, Typography } from "components/controls/widget";
import PageTitle from "common/web/PageTitle";
import PageHeader from "common/web/PageHeader";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import { Faq, apiGetFaqs } from "common/api/Faqs";
import FaqsItem from "./FaqsItem";
import FaqsRootItem from "./FaqsRootItem";
import pathToFaqs, { RouteProps } from "./routes-path";

const LabelOkruhId: number = 1;

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    labelFaq?: Faq;
    seznamFaqs: Faq[];
}

interface FaqsPageProps {
    labelId: number;
}

type PropsType = FaqsPageProps & State & ActionsExecutorPropsType & RouteComponentProps<RouteProps> & WithStyles<typeof styles>;

const initialState: State = {
    loading: true,
    hasError: false,
    seznamFaqs: [],
}

class FaqsPage extends React.PureComponent<PropsType> {

    loadFaqs = (labelId: number) => {

        const { executeAction, updateState } = this.props;

        const action = apiGetFaqs(labelId, false)
            .onSuccess(d => {
                var labelFaq: Faq = undefined;
                var seznamFaqs = d;
                if (labelId != LabelOkruhId) {
                    const idx = seznamFaqs.findIndex(this.isLabelFaq);
                    if (idx >= 0) {
                        labelFaq = seznamFaqs[idx];
                        seznamFaqs.splice(idx, 1);
                    }
                }
                updateState({ loading: false, seznamFaqs: seznamFaqs, labelFaq: labelFaq });
            })
            .onError(e => {
                const errMessage = "Error: " + e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false });
    }

    isLabelFaq = (f: Faq): boolean => {
        return f.labels.some(id => id == LabelOkruhId);
    }

    getLabelPath = (faq: Faq): string => {

        const labelId = faq.labels.find((id) => id != 1);

        return pathToFaqs.replace(':labelId', labelId.toString())
            .replace(':lang', this.props.match.params.lang)
    }

    getBackPath = (): string => {

        return pathToFaqs.replace('/:labelId', '')
            .replace(':lang', this.props.match.params.lang)
    }

    componentWillReceiveProps(newProps: PropsType) {
        if (this.props.labelId != newProps.labelId) {
            this.loadFaqs(newProps.labelId);
        }
    }

    componentDidMount() {
        this.loadFaqs(this.props.labelId);
    }

    render() {
        const { labelFaq, seznamFaqs, loading, hasError, error, classes } = this.props;
        const isRootLabel = labelFaq === undefined;
        const title: React.ReactNode = isRootLabel
            ? "Často kladené dotazy"
            : <span><Link to={this.getBackPath()}>{"Často kladené dotazy"}</Link>{"  »  " + labelFaq.question}</span>;// this.getBackPath();

        return <div>
            <PageTitle title={title} />
            {loading
                ? <Loading loading={loading} color="primary" />
                : hasError
                    ? <Error>{error}</Error>
                    : <div>
                        <PageHeader>
                            <Typography variant="h5">{[isRootLabel ? 'Okruhy otázek' : labelFaq.question]}</Typography>
                        </PageHeader>

                        <Grid container spacing={24} direction="column" className={classes.itemsContainer}>
                            {seznamFaqs.map((i, k) => <Grid key={i.id} item>
                                {isRootLabel
                                    ? <FaqsRootItem faq={i} labelPath={this.getLabelPath(i)} />
                                    : <FaqsItem faq={i} />
                                }
                            </Grid>)}
                        </Grid>
                    </div>
            }
        </div>
    }
}


const styles = (theme: Theme) => createStyles({
    itemsContainer: {
        padding: 2 * theme.spacing.unit,
    },
});

export default withStyles(styles)(withActionsExecutor<FaqsPageProps, State>(initialState, withRouter(FaqsPage))); 